const initState = {
  isCommenting: false,
  error: null,
}

export default initState
